import get_image_src from "./get_image_src"

export default (product, quality) => get_image_src((product?.images)?.[0] || {}, quality)
